import { catalog } from "../i18n.js";

/** The message box (components/Composer.tsx): attachments, replies, the mic and its listening bar. */
export const COMPOSER = catalog(
  {
    attachment: "attachment",
    remove: "Remove",
    removeAttachment: "Remove attachment",
    mention: "Mention",
    replyingTo: (author: string) => `Replying to ${author}`,
    stopReplying: "Stop replying to this message",

    listening: "Listening…",
    listeningAutoSend: "Listening… sends when you stop",
    dictatingIn: (language: string) => `Dictating in ${language}. Choose another language`,
    dictationLanguageIs: (language: string) => `Dictation language: ${language}`,
    dictationLanguage: "Dictation language",
    autoSend: "Auto-send",
    autoSendOn: "Auto-send is on: the message is sent when you stop speaking",
    autoSendOff: "Auto-send is off: press Send when you are ready",
    takeBack: "Stop and remove what was heard",
    takeBackTitle: "Stop and remove what was heard (Esc)",
    dismiss: "Dismiss",

    attachPicture: "Attach a picture",
    dropPicture: "Drop the picture here",
    messageTo: (name: string) => `Message ${name}`,
    dictate: "Dictate",
    dictateIn: (language: string) => `Dictate (${language})`,
    stopDictating: "Stop dictating",
    stopDictatingAndSend: "Stop dictating and send",
    stopDictatingKeep: "Stop dictating, keep the words",
    send: "Send",
    sendTitle: "Send (Enter)",
  },
  {
    attachment: "lampiran",
    remove: "Hapus",
    removeAttachment: "Hapus lampiran",
    mention: "Sebut",
    replyingTo: (author: string) => `Membalas ${author}`,
    stopReplying: "Batal membalas pesan ini",

    listening: "Mendengarkan…",
    listeningAutoSend: "Mendengarkan… terkirim saat kamu berhenti",
    dictatingIn: (language: string) => `Mendikte dalam ${language}. Pilih bahasa lain`,
    dictationLanguageIs: (language: string) => `Bahasa dikte: ${language}`,
    dictationLanguage: "Bahasa dikte",
    autoSend: "Kirim otomatis",
    autoSendOn: "Kirim otomatis nyala: pesan terkirim saat kamu berhenti bicara",
    autoSendOff: "Kirim otomatis mati: tekan Kirim kalau sudah siap",
    takeBack: "Hentikan dan hapus yang terdengar",
    takeBackTitle: "Hentikan dan hapus yang terdengar (Esc)",
    dismiss: "Tutup",

    attachPicture: "Lampirkan gambar",
    dropPicture: "Lepas gambarnya di sini",
    messageTo: (name: string) => `Pesan ke ${name}`,
    dictate: "Dikte",
    dictateIn: (language: string) => `Dikte (${language})`,
    stopDictating: "Berhenti mendikte",
    stopDictatingAndSend: "Berhenti mendikte dan kirim",
    stopDictatingKeep: "Berhenti mendikte, simpan kata-katanya",
    send: "Kirim",
    sendTitle: "Kirim (Enter)",
  },
);
